/* unplugin-vue-components disabled */import { render } from "./Vote.vue?vue&type=template&id=4e35cd08&scoped=true&ts=true"
import script from "./Vote.vue?vue&type=script&lang=ts"
export * from "./Vote.vue?vue&type=script&lang=ts"

import "./Vote.vue?vue&type=style&index=0&id=4e35cd08&lang=scss&scoped=true"

import exportComponent from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e35cd08"]])

export default __exports__